import React, { useState, useContext } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import Button from '@material-ui/core/Button';
import { MeetingContext } from '../../App';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 2,
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    title: {
      fontSize: '2rem',
      textAlign: 'center',
      padding: '1rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.5rem',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: '3rem',
      },
    },
    main: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFF',
    },
    feedbackTitle: {
      padding: '5px',
      fontSize: '1.5rem',
      color: '#239B56',
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '15px',
      },
    },
    submit: {
      [theme.breakpoints.between('sm', 'md')]: {
        marginTop: '15px',
      },
    },
    reviewText: {
      fontSize: '1.5rem',
      color: '#5DADE2',
      [theme.breakpoints.between('sm', 'md')]: {
        marginBottom: '15px',
      },
    },
    logo: {
      width: 'auto',
      height: '30px',
      margin: ' 0px 3px',
    },
    gif: {
      height: '350px',
      maxWidth: '100%',
      [theme.breakpoints.between('sm', 'md')]: {
        height: '550px',
      },
    },
    footerContent: {
      display: 'flex',
      alignItems: 'center',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      [theme.breakpoints.between('sm', 'md')]: {
        justifyContent: 'center',
      },
      flexGrow: 2,
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      backgroundColor: '#ECF0F1',
    },
    powered: {
      color: '#5D6D7E',
    },
  })
);

export default function MeetingEnd({ meetingEndedByHost }) {
  const classes = useStyles();
  const [reviewSubmitted, setReviewSubmitted] = useState(false);
  const { company, meeting, validLink } = useContext(MeetingContext);
  const endText =
    meeting?.meeting_status === 'OPEN'
      ? `Your Remote Session with ${company.company_name} has Ended`
      : !validLink
      ? 'The Meeting Link is Invalid'
      : 'The Meeting has been Ended';

  return (
    <>
      <div className={classes.main}>
        <div className={classes.title}>{endText}</div>
        <div className={classes.container}>
          {meeting?.meeting_status === 'OPEN' && (
            <>
              <video
                className={classes.gif}
                autoPlay
                loop
                muted
                playsinline
                src={require('../../assests/gif/meetingEndGif.mp4')}
              ></video>
              <div className={classes.section}>
                {!reviewSubmitted ? (
                  <>
                    <div className={classes.reviewText}>Rate your Experience?</div>
                    <Rating name="half-rating" defaultValue={5} precision={0.5} size="large" />
                    <Button className={classes.submit} variant="contained" onClick={() => setReviewSubmitted(true)}>
                      Submit
                    </Button>
                  </>
                ) : (
                  <>
                    <div className={classes.feedbackTitle}>Thank you for your Response.</div>
                  </>
                )}
              </div>
            </>
          )}
          <div className={classes.footer}>
            <div className={classes.footerContent}>
              <span className={classes.powered}>Powered by</span>
              <img
                className={classes.logo}
                src={require('../../assests/images/zuper-trans-logo.png')}
                alt="zuper_logo"
              ></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
